module.exports = __webpack_public_path__ + "img/4.53ab7e89.png";